import { useTranslation } from "react-i18next";
import { ReactComponent as Partager } from "../../../assets/partager.svg";
import { ReactComponent as Facebook } from "../../../assets/Facebook.svg";
import { ReactComponent as Twitter } from "../../../assets/Twitter.svg";
import { ReactComponent as Pinterest } from "../../../assets/pinterest.svg";
import { ReactComponent as Mail } from "../../../assets/mail.svg";
import style from "./style.module.scss";

const SocialShare = ({ imageUrl }) => {
  const href = window.location.href;
  // React i18next
  const { t } = useTranslation();

  return (
    <div className={style.block}>
      <div className={style.shareIcon}>
        <Partager />
      </div>

      <span className={style.label}>{t("Share")}</span>

      <div className={style.socials}>
        <a
          className={style.social}
          href={`https://www.twitter.com/share?url=${href}`}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={t("Share on Twitter")}
        >
          <Twitter />
        </a>
        <a
          className={style.social}
          href={`https://www.facebook.com/sharer.php?u=${href}`}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={t("Share on Facebook")}
        >
          <Facebook />
        </a>
        {imageUrl && (
          <a
            className={style.social}
            href={`https://pinterest.com/pin/create/link/?url=${href}&media=${imageUrl}`}
            rel="noopener noreferrer"
            target="_blank"
            aria-label={t("Share on Pinterest")}
          >
            <Pinterest />
          </a>
        )}
        <a
          href={`mailto:?body=${href}`}
          className={style.social}
          aria-label={t("Share by mail")}
        >
          <Mail />
        </a>
      </div>
    </div>
  );
};

export default SocialShare;
